import { appConfig } from "../../system/types/app/appConfig";
import { language } from "../../system/types/project/language";
import {SYSTEM_ACTIONS} from "./types";

export const systemToggleDarkTheme = () => {
    return {
        type: SYSTEM_ACTIONS.systemToggleDarkTheme,
    };
};

export const systemSetLanguages = (languages: language[]) => {
    return {
        type: SYSTEM_ACTIONS.systemSetLanguages,
        payload: languages,
    };
};

export const systemSetAppConfig = (appConfig: appConfig) => {
    return {
        type: SYSTEM_ACTIONS.systemSetAppConfig,
        payload: appConfig,
    };
};
